import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, IconButton, Typography } from '@altermaind/web/ui';
// eslint-disable-next-line @altermaind/no-build-import
import hardSkillAnswerGuide from '@/_shared/assets/documents/Hard_skill_assessment_Spiegazione_risposte.pdf';
import { AlertBadge } from '@/_shared/components/AlertBadge';
import { Charts } from '@/_shared/components/Charts';
import { Routes } from '@/_shared/constants/routes';
import { downloadFile } from '@/_shared/helpers/download';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { getSurveyCampaignByIdResponsesResultsStatsCall, useCurrentTemplate } from '../../state';

export const DistributionBox: FC = () => {
  const t = useTranslations('surveys.details.stats.tabDepartments.distributionBox');
  const { genericResponsiveValue } = useResponsiveStyle();
  const { departmentsStats } = getSurveyCampaignByIdResponsesResultsStatsCall.hook();
  const navigate = useNavigate();

  const { currentName, isHardSkillSurvey } = useCurrentTemplate();

  const { isDesktop } = useBreakingPoints();

  const goToDepartments = () => {
    navigate(Routes.Departments);
  };

  return (
    <>
      <AlertBadge
        onClick={goToDepartments}
        type='primary'
        iconName='lightBulb'
        label={t('goToDepartments')}
      />
      <Box>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          mb='xs'
          mt='m'
          flexDirection={genericResponsiveValue({
            breakPoints: { mobile: 'column' },
            defaultValue: 'row',
          })}
        >
          <Typography variant='h2'>{t('title')}</Typography>
          {isHardSkillSurvey ? (
            <IconButton
              prefixSvg='download'
              svgStyle={{ fill: 'primary/text', size: 'xs' }}
              textStyle={{ ml: 'xxxs' }}
              onClick={() =>
                downloadFile(hardSkillAnswerGuide, 'Hard Skill assessment Spiegazione risposte')
              }
              variant='link/primary'
            >
              {t('downloadAnswerGuide')}
            </IconButton>
          ) : null}
        </Box>
        <Typography variant='p3/light' mb='l'>
          {t('description', { currentName: currentName.toLowerCase() })}
        </Typography>
        <Charts.BarChartComponent
          defaultItemsSize={isDesktop ? 6 : 2}
          data={
            departmentsStats?.map(department => {
              const value =
                department?.totalCompletedSurveys !== undefined &&
                department?.totalInvited !== undefined &&
                department.totalInvited > 0
                  ? (department.totalCompletedSurveys / department.totalInvited) * 100
                  : 0;

              return {
                name: `${department.departmentName}\n${department.totalCompletedSurveys}/${
                  department.totalInvited
                }`,
                value: Number(value.toFixed(0)),
                label: value > 0 ? `${value.toFixed(0)}%` : '0%',
              };
            }) || []
          }
        />
      </Box>
    </>
  );
};
